export default __webpack_public_path__ + "static/media/7-bm.40a77d78.webp";